// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCrossSelling from "../Restaumatic.Menu.V2.Types.CrossSelling/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const Menu = x => x;
const newtypeMenu_ = {Coercible0: () => {}};
const hasFieldMenu = dictHasField => dictHasField;
const eqMenu = {
  eq: x => y => (() => {
    if (x.calculatedCrossSellingList.tag === "Nothing") { return y.calculatedCrossSellingList.tag === "Nothing"; }
    if (x.calculatedCrossSellingList.tag === "Just") {
      if (y.calculatedCrossSellingList.tag === "Just") {
        return Restaumatic$dMenu$dV2$dTypes$dCrossSelling.eqCalculatedCrossSellingL.eq(x.calculatedCrossSellingList._1)(y.calculatedCrossSellingList._1);
      }
      return false;
    }
    return false;
  })() && x.name === y.name && x.onlineOrdering === y.onlineOrdering && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.sections)(y.sections)
};
const genericMenu = {to: x => x, from: x => x};
const showMenu = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "calculatedCrossSellingList",
              (() => {
                if (v.calculatedCrossSellingList.tag === "Just") {
                  return "(Just " + Restaumatic$dMenu$dV2$dTypes$dCrossSelling.showCalculatedCrossSellingList.show(v.calculatedCrossSellingList._1) + ")";
                }
                if (v.calculatedCrossSellingList.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["name", Data$dShow.showStringImpl(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "onlineOrdering",
              v.onlineOrdering ? "true" : "false"
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["sections", $0(v.sections)]))([]))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "Menu"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenu = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "calculatedCrossSellingList"})(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.unscrambleDecodeCalculatedCrossSellingList))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "name"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({reflectSymbol: () => "onlineOrdering"})(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "sections"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeMenu = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenu)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Menu"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "sections"
    })((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "onlineOrdering"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "name"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "calculatedCrossSellingList"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCalculatedCrossSellingList.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeMenu = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenu)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Menu"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "sections"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "onlineOrdering"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "name"})({
    decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "calculatedCrossSellingList"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCalculatedCrossSellingList.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {Menu, decodeMenu, encodeMenu, eqMenu, genericMenu, hasFieldMenu, newtypeMenu_, showMenu, unscrambleDecodeMenu};
